import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { PropertyFilterSearchQuery } from "__generated__/api/";
import PropertySearchListings = PropertyFilterSearchQuery.PropertySearchListings;

export const bexApiPropertyAdapter = (data: PropertySearchListings): Hotel | null => {
  if (data.__typename !== "Property") {
    return null;
  }

  return {
    hotelId: data.id,
    hotelName: data.name,
    resultType: "",
    hotelDefaultName: data.name,
    hotelStarRating: String(data.star),
    hotelImageUrl: data.propertyImage?.image.url,
    hotelImageUrls: { y: data.propertyImage?.image.url },
    shortDescription: "",
    hotelStreetAddress: data.destinationInfo?.distanceFromMessaging || "",
    hotelFormattedFullAddress: data.destinationInfo?.distanceFromMessaging || "",
    hotelCity: "",
    hotelProvince: "",
    hotelCountryCode: "",
    hotelPostalCode: "",
    hotelLatitude: data.mapMarker?.latLong.latitude || 0,
    hotelLongitude: data.mapMarker?.latLong.longitude || 0,
    hotelOverallReviewRating: data.reviews?.score || 0,
    reviewCount: data.reviews?.total || 0,
    recommendedPercent: 0,
    featuredReviews: [
      {
        authorName: "",
        rating: data.reviews?.score || 0,
        review: "",
        reviewDate: "",
        title: "",
        ugcSource: false,
      },
    ],
    checkInDate: "",
    checkOutDate: "",
    lengthOfStay: 0,
    formattedPrice: data.price?.options?.[0]?.displayPrice?.formatted || "",
    affinities: [],
    hotelInfositeUrl: "/Hotel-Search?",
    datedHotelInfositeUrl: data.propertyDetailsLink?.uri.relativePath || "",
    pinnedHotelSearchResultUrl: "/Hotel-Search?",
    priceCallToActionUrl: data.propertyDetailsLink?.uri.relativePath || "",
    callToActionHotelNameUrl: data.propertyDetailsLink?.uri.value
      ? new URL(data.propertyDetailsLink?.uri.value).pathname
      : "",
    hotelPrice: {
      value: String(data.price?.options?.[0]?.displayPrice?.amount),
      currency: data.price?.options?.[0]?.displayPrice?.currencyInfo?.code || "",
      percentSavings: 0,
    },
    mandatoryFee: {
      formattedValue: "",
    },
    isoCheckIn: "",
    isoCheckOut: "",
    labels: {},
    source: "",
    promotion: "",
    nearPoi: {
      name: "",
      walkTime: 1,
    },
    distancePoi: {
      miles: 0,
      kilometers: 0,
    },
    payLater: Boolean(data.offerSummary?.messages?.some((item) => item.type === "PAY_LATER")),
    freeCancellation: Boolean(data.offerSummary?.messages?.some((item) => item.type === "FREE_CANCEL")),
    apsReviewCount: 0,
    imageFallback: false,
    nearestLocation: undefined,
    travelerReviewContent: undefined,
    hotelAmenityCategories: [],
    structure: data.structureType,
    boundaryDistance: {
      unit: data.destinationInfo?.distanceFromDestination?.unit || "",
      value: data.destinationInfo?.distanceFromDestination?.value || 0,
    },
    directDistance: {
      unit: data.destinationInfo?.distanceFromDestination?.unit || "",
      value: data.destinationInfo?.distanceFromDestination?.value || 0,
    },
  };
};
